export function getCORSSafeURL(url: string) {
  try {
    const urlObj = new URL(url);
    return `${window.location.origin}${urlObj.pathname}`;
  } catch {
    return url;
  }
}
